var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-1"},[_c('v-col',{staticClass:"py-0"},[_c('v-textarea',_vm._b({staticStyle:{"width":"100%"},attrs:{"value":_vm.pValue,"label":_vm.lgLabel,"disabled":_vm.formDisabled,"auto-grow":"","dense":"","outlined":""},on:{"input":v => _vm.handleUpdate({ value: v })}},'v-textarea',{ ..._vm.$attrs },false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }